// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mdi-delete:hover{color:#c62828}.child-align{padding-left:73px!important}.bold-item-activator{font-weight:900!important}.v-list--dense .v-list-item .v-list-item__subtitle,.v-list--dense .v-list-item .v-list-item__title,.v-list-item--dense .v-list-item__subtitle,.v-list-item--dense .v-list-item__title{font-weight:unset!important}.clear-bg{background:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
